export enum CONTACT_TYPE {
  CALL = 1,
  CHAT = 2
}
